import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import IntegrationsBrowser, {
  IntegrationCardData,
} from "@apps/org-settings/components/integrations/integrations-browser";
import { assertNonNull } from "@helpers/helpers";

import { GetAccountQuery } from "../../../types/graphql-schema";
import AiToolsCard from "./integrations/ai-tools-card";
import IntegrationDetailDialog from "./integrations/integration-detail-page";
import { PERSONAL_INTEGRATIONS } from "./integrations/integrations-config";
import McpIntegrationDialog from "./integrations/mcp-integration-dialog";

const AI_TOOLS_SLUG = "ai-tools";

const Integrations = ({ me }: { me: GetAccountQuery["me"] }) => {
  const account = assertNonNull(me);
  const location = useLocation();
  const history = useHistory();
  const [openSlug, setOpenSlug] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const slug = params.get("open");
    if (slug) {
      setOpenSlug(slug);
      params.delete("open");
      const search = params.toString();
      history.replace({
        pathname: location.pathname,
        search: search ? `?${search}` : "",
      });
    }
  }, [location.pathname, location.search, history]);

  const { enabled, available } = useMemo(() => {
    const enabledCards: IntegrationCardData[] = [];
    const availableCards: IntegrationCardData[] = [];
    PERSONAL_INTEGRATIONS.forEach((definition) => {
      const card: IntegrationCardData = {
        slug: definition.slug,
        name: definition.name,
        logo: definition.logo,
        summary: definition.summary,
        categories: definition.categories,
      };
      if (definition.isConnected(account)) {
        enabledCards.push(card);
      } else {
        availableCards.push(card);
      }
    });
    return { enabled: enabledCards, available: availableCards };
  }, [account]);

  const closeDialog = () => setOpenSlug(null);

  return (
    <div>
      <IntegrationsBrowser
        enabled={enabled}
        available={available}
        onSelect={setOpenSlug}
        topSlot={<AiToolsCard onClick={() => setOpenSlug(AI_TOOLS_SLUG)} />}
      />

      <McpIntegrationDialog
        open={openSlug === AI_TOOLS_SLUG}
        onClose={closeDialog}
      />

      <IntegrationDetailDialog
        account={account}
        slug={openSlug && openSlug !== AI_TOOLS_SLUG ? openSlug : ""}
        open={!!openSlug && openSlug !== AI_TOOLS_SLUG}
        onClose={closeDialog}
      />
    </div>
  );
};

export default Integrations;
